export interface NoteForPatient {
	_id: string
	note: {
		title: string
		body: string
		patientSatisfaction: number
	}
	coachData: Array<string>
	created: string
}

export interface NotesForPatientState {
	notes: Array<NoteForPatient>
}

export enum NOTES_FOR_PATIENT_ACTION_TYPES {
	NOTES_FOR_PATIENT_SET_DATA = 'NOTES_FOR_PATIENT_SET_DATA',
}

export interface NotesForPatientSetDataAction {
	type: NOTES_FOR_PATIENT_ACTION_TYPES.NOTES_FOR_PATIENT_SET_DATA
	payload: Array<NoteForPatient>
}

export type NotesForPatientActions = NotesForPatientSetDataAction
